import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonRefresher,
  IonRefresherContent,
  IonLabel,
  IonChip,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonIcon,
  IonList,
  IonItem,
  IonBadge,
} from "@ionic/react";

import {
  add,
  chevronDownCircleOutline,
  skullOutline,
  constructOutline,
  listOutline,
} from "ionicons/icons";
import { InventoryLocationPartnerType } from "../services/inventoryLocation.service";
import { useEffect, useState } from "react";
import Leads from "../components/Leads";
import { doReload } from "../hooks/common";
import useNavigation from "../hooks/useNavigation";
import {
  getOpenLeads,
  getUnattendedLeads,
  getUpcomingFollowups,
} from "../services/lead.service";
import { getUpcomingTasks } from "../services/maintenance.service";
import { getTickets } from "../services/ticket.service";
import Maintenances from "../components/Maintenances";
import { useRecoilValue } from "recoil";
import {
  userProfileState,
} from "../services/state.service";
import { useLocation } from "react-router";
import { getExpiredPlotsCount, getInactivePlotsCount } from "../services/plot.service";

import { getOrders } from "../services/order.service";
import Orders from "../components/Orders";
import { getUpcomingActivityFollowups } from "../services/sales.service";
import { getEnquiriesCount } from "../services/enquiry.service";
import SalesActivityFollowUpCard from "../components/SalesActivityFollowUpCard";

const Home: React.FC = () => {
  const navigateTo = useNavigation();
  const location = useLocation();
  const userProfile: any = useRecoilValue(userProfileState);

  const [openLeads, setOpenLeads] = useState(0);
  const [openTicketsCount, setOpenTicketsCount] = useState(0);
  const [faultyPlots, setFaultyPlots] = useState(0);
  const [expiredPlots, setExpiredPlots] = useState(0);
  const [enquiriesCount, setEnquiriesCount] = useState(0);

  const [orders, setOrders] = useState([] as any[]);



  useEffect(() => {
    let mounted = true;
    getOpenLeads(userProfile.username).then((item) => {
      if (mounted) {
        setOpenLeads(item?.count);
      }
    });
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    let mounted = true;

    if (!!userProfile?.regionIds?.length) {

      getInactivePlotsCount(userProfile).then((count) => {
        if (mounted) {
          setFaultyPlots(count);
        }
      });

      getExpiredPlotsCount(userProfile).then((count) => {
        if (mounted) {
          setExpiredPlots(count);
        }
      });
    }

    return () => {
      mounted = false;
    };
  }, []);

  const [unattendedLeads, setUnattendedLeads] = useState(0);
  useEffect(() => {
    let mounted = true;
    getUnattendedLeads(userProfile.username).then((item) => {
      if (mounted) {
        setUnattendedLeads(item.count);
      }
    });
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    let mounted = true;
    if (userProfile?.farmUserId && location.pathname === "/tabs/home") {
      getEnquiriesCount({
        and: [
          { assigneeId: userProfile.farmUserId },
          { or: [{ status: 'NEW' }, { status: 'OPEN' }] },
        ],
      }).then((count) => {
        if (mounted) setEnquiriesCount(count);
      }).catch((error) => {
        console.error("Error fetching enquiries count:", error);
        if (mounted) setEnquiriesCount(0);
      });
    }
    return () => {
      mounted = false;
    };
  }, [userProfile, location]);

  useEffect(() => {
    let mounted = true;
    if (userProfile?.farmUserId && location.pathname === "/tabs/home") {
      getTickets({ assigneeId: userProfile.farmUserId, status: 'open' }, 1, 0)
        .then((res) => {
          if (mounted) setOpenTicketsCount(res.total ?? 0);
        })
        .catch(error => {
          console.error("Error fetching tickets:", error);
          if (mounted) setOpenTicketsCount(0);
        });
    }

    return () => {
      mounted = false;
    };
  }, [userProfile, location]);

  const [followups, setFollowups] = useState([] as any[]);
  const [activityFollowups, setActivityFollowups] = useState([] as any[]);

  useEffect(() => {
    let mounted = true;
    getUpcomingFollowups(userProfile.username).then((items) => {
      if (mounted) setFollowups(items);
    });
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    let mounted = true;
    getUpcomingActivityFollowups(userProfile.username).then((items) => {
      if (mounted) setActivityFollowups(Array.isArray(items) ? items : []);
    });
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    let mounted = true;
    fetchOrders(mounted);
    return () => {
      mounted = false;
    };
  }, []);

  const fetchOrders = (mounted: boolean, skip: number = 0) => {
    // Create an array of lead stages to filter by
    const leadStages = ["later"];

    getOrders(
      "",
      userProfile?.farmUserId,
      skip,
      { stage: { in: leadStages } } // Pass the filter as an object
    ).then((items) => {
      if (mounted) {
        // Get the current date
        const currentDate = new Date();

        // Filter orders to include only those with followUpdate within 7 days
        const filteredOrders = items?.filter((order: any) => {
          const followUpdateDate = new Date(order.followUpDate);
          const timeDiff = followUpdateDate.getTime() - currentDate.getTime();
          const dayDiff = timeDiff / (1000 * 3600 * 24);
          return dayDiff <= 7 && dayDiff >= -1;
        });
        setOrders(filteredOrders); // Set the filtered orders
      }
    });
  };

  // const [tasks, setTasks] = useState([] as any[]);
  // useEffect(() => {
  //   let mounted = true;
  //   getUpcomingTasks(userProfile.username).then((items) => {
  //     if (mounted) {
  //       setTasks(items);
  //     }
  //   });
  //   return () => {
  //     mounted = false;
  //   };
  // }, []);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>Home</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonRefresher slot="fixed" onIonRefresh={doReload}>
          <IonRefresherContent
            pullingIcon={chevronDownCircleOutline}
            pullingText="Pull to refresh"
            refreshingSpinner="circles"
            refreshingText="Refreshing..."
          ></IonRefresherContent>
        </IonRefresher>
        <IonGrid>
          <IonRow>
            <IonCol className="ion-align-self-center">
              <IonChip>
                <IonLabel>Quick Links</IonLabel>
              </IonChip>
            </IonCol>
          </IonRow>
        </IonGrid>
        <IonGrid>
          <IonRow>
            <IonCol className="ion-align-self-center">
              {/* <IonButton
                size="small"
                onClick={() => navigateTo("/tabs/lead", { leadId: null })}
              >
                <IonIcon slot="start" icon={add} />
                Lead
              </IonButton> */}
              <IonButton
                size="small"
                onClick={() => navigateTo("/salesPlans", { reload: true })}
              >
                <IonIcon slot="start" icon={add} />
                Activity
              </IonButton>
              {/* <IonButton
                size="small"
                onClick={() =>
                  navigateTo("/tabs/maintenance", { maintenanceId: null })
                }
              >
                <IonIcon slot="start" icon={add} />
                Maintenance
              </IonButton> */}
              <IonButton
                size="small"
                onClick={() => {
                  navigateTo("/event", {})
                }}
              >
                <IonIcon slot="start" icon={add} />
                Events
              </IonButton>
              <IonButton
                size="small"
                onClick={() => navigateTo("/faulty-plots", {})}
              >
                <IonIcon slot="start" icon={skullOutline} />
                Faulty Plots
              </IonButton>
              <IonButton
                size="small"
                onClick={() => navigateTo("/tabs/test-devices", {})}
              >
                <IonIcon slot="start" icon={constructOutline} />
                Testing Devices
              </IonButton>
              <IonButton
                size="small"
                onClick={() => navigateTo("/tabs/order", { orderId: null })}
              >
                <IonIcon slot="start" icon={add} />
                Order
              </IonButton>
              <IonButton
                size="small"
                onClick={() =>
                  navigateTo("/tabs/add-channel-partner", {
                    partnerType: InventoryLocationPartnerType.DISTRIBUTOR,
                  })
                }
              >
                <IonIcon slot="start" icon={add} />
                Distributor
              </IonButton>
              <IonButton
                size="small"
                onClick={() =>
                  navigateTo("/tabs/add-channel-partner", {
                    partnerType: InventoryLocationPartnerType.RETAILER,
                  })
                }
              >
                <IonIcon slot="start" icon={add} />
                Retailer
              </IonButton>
              <IonButton size="small" onClick={() => navigateTo("/tabs/channel-partners", {})}>
                <IonIcon slot="start" icon={listOutline} />
                My Channel Partners
              </IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>
        <IonList>
          <IonItem onClick={() => navigateTo("/tabs/leads", {})}>
            <IonBadge slot="end">{openLeads}</IonBadge>
            <IonLabel>Open leads</IonLabel>
          </IonItem>
          <IonItem onClick={() => navigateTo("/tabs/leads", {})}>
            <IonBadge slot="end">{unattendedLeads}</IonBadge>
            <IonLabel>Unattended leads</IonLabel>
          </IonItem>
          <IonItem onClick={() => navigateTo("/tabs/tickets", {})}>
            <IonBadge slot="end">{openTicketsCount}</IonBadge>
            <IonLabel>Open Tickets</IonLabel>
          </IonItem>
          <IonItem onClick={() => navigateTo("/tabs/enquiries", {})}>
            <IonBadge slot="end">{enquiriesCount}</IonBadge>
            <IonLabel>Enquiries</IonLabel>
          </IonItem>
          {faultyPlots > 0 && (
            <IonItem onClick={() => navigateTo("/faulty-plots", {})}>
              <IonBadge slot="end">{faultyPlots}</IonBadge>
              <IonLabel>Inactive Plots</IonLabel>
            </IonItem>
          )}
          {expiredPlots > 0 && (
            <IonItem onClick={() => navigateTo("/expired-plots", {})}>
              <IonBadge slot="end">{expiredPlots}</IonBadge>
              <IonLabel>Expired Plots</IonLabel>
            </IonItem>
          )}
        </IonList>

        <IonGrid>
          <IonRow>
            <IonCol className="ion-align-self-center">
              <IonChip>
                <IonLabel>Upcoming Follow-ups</IonLabel>
              </IonChip>
            </IonCol>
          </IonRow>

          <IonRow>
            <IonCol>
              <Orders
                orders={orders}
                onOrderUpdate={() => fetchOrders(true, 0)}
              />
            </IonCol>
          </IonRow>
        </IonGrid>
        <Leads leads={followups} />

        {activityFollowups.length > 0 && (
          <IonGrid>
            <IonRow>
              <IonCol>
                {activityFollowups.map((activity: any) => (
                  <SalesActivityFollowUpCard
                    key={activity.id}
                    activity={activity}
                    onDismiss={(id) => setActivityFollowups(prev => prev.filter(a => a.id !== id))}
                  />
                ))}
              </IonCol>
            </IonRow>
          </IonGrid>
        )}
        {/* <IonGrid>
          <IonRow>
            <IonCol className="ion-align-self-center">
              <IonChip>
                <IonLabel>Upcoming Maintenances</IonLabel>
              </IonChip>
            </IonCol>
          </IonRow>
        </IonGrid>
        <Maintenances maintenances={tasks} /> */}
      </IonContent>
    </IonPage>
  );
};

export default Home;
